// extracted by mini-css-extract-plugin
export default {"lfooter":"footer_lfooter__H8MY2"};